import React from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Sidebar from "./components/SideBar";
import BrowseProjects from "./screens/student/BrowseProjects";
import SignUp from "./screens/student/Signup";
import SignIn from "./screens/student/Signin";
import ForgotPassword from "./screens/student/ForgotPassword";
import ResetPassword from "./screens/student/ResetPassword";
import MyProjects from "./screens/student/MyProjects";
import { useUser } from "./contextProviders/userContext";
import AdminProjectsTable from "./screens/admin/AllProjects";
import AdminStudentsView from "./screens/admin/AllStudents";
import AdminProjectDetailView from "./screens/admin/ProjectDetailView";
import AdminDashboard from "./screens/admin/AdminDashboard";
import StudentDashboard from "./screens/student/StudentDashboard";
import EmailVerification from "./screens/student/EmailVerification";
import AnnouncementsPage from "./screens/common/AnnouncementsPage";
import StudentAnnouncementsPage from "./screens/student/ StudentAnnouncementsPage";
import AdminAnnouncementsPage from "./screens/admin/AdminAnnouncementsPage";
import LandingPage from "./screens/common/LandingPage";
import SettingsPage from "./screens/student/SettingsPage";
import HelpCenterPage from "./screens/student/HelpCenterPage";
import DirectMessages from "./screens/common/DirectMessages";
import AdminReports from "./screens/admin/AdminReports";


const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

const AppContent = () => {
  const location = useLocation();
  const hideSidebarRoutes = ["/signup", "/signin", "/forgot-password"];
  const showSidebar = !hideSidebarRoutes.includes(location.pathname);

  return (
    <div
      className="App"
      style={{
        display: "flex",
        backgroundColor: "#fff",
        maxHeight: "100vh",
        overflowY: "scroll",
      }}>
      {/* {showSidebar && <Sidebar />} */}
      <main style={{ flexGrow: 1, padding: "0px", paddingTop: "0px" }}>
        <Routes>
          {/* <Route path="/" element={<SignUp />} /> */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <StudentDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/browse"
            element={
              <ProtectedRoute>
                <BrowseProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/myprojects"
            element={
              <ProtectedRoute>
                <MyProjects />
              </ProtectedRoute>
            }
          />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/verify/:token" element={<EmailVerification />} />

          <Route
            path="/announcements"
            element={
              <ProtectedRoute>
                <StudentAnnouncementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <DirectMessages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <HelpCenterPage />
              </ProtectedRoute>
            }
          />
          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminProjectsTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects/:projectId"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminProjectDetailView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/students"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminStudentsView />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/announcements"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminAnnouncementsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reports"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminReports />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
